import http from './http';

// `http` interceptor reads token from localStorage; pre-auth endpoints
// (login/register/first-login) skip header injection because token is null.

export const login = (email, password) =>
  http.post('/auth/login', { email, password }).then((r) => r.data);

export const register = (email, password, name) =>
  http.post('/auth/register', { email, password, name }).then((r) => r.data);

export const firstLogin = (payload) =>
  http.post('/auth/first-login', payload).then((r) => r.data);

export const getMe = () =>
  http.get('/auth/me').then((r) => r.data);

export const updateProfile = (payload) =>
  http.put('/auth/profile', payload).then((r) => r.data);

export const changePassword = (payload) =>
  http.post('/auth/profile/change-password', payload).then((r) => r.data);
